/**
 * Overlay bridge that delegates to ModalService (Preact)
 * Maintains the same API (openOverlay/closeOverlay/confirmOverlay)
 */
import { ModalService } from '../ui-kit/ModalService.jsx';

const map = new Map();

export function openOverlay({ title = '', content = '', actions = [] } = {}) {
  const id = `overlay-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const mapped = (actions || []).map(a => ({
    text: a.text || a.label,
    class: a.class || a.className || 'uk-btn uk-btn-secondary',
    action: a.action || a.handler || (() => {})
  }));
  const close = ModalService.open({ title, content, actions: mapped });
  map.set(id, close);
  return id;
}

export function closeOverlay(id) {
  const close = map.get(id);
  if (close) {
    try { close(); } catch (_) {}
    map.delete(id);
  }
}

export function confirmOverlay(title, message, onConfirm, onCancel) {
  const id = openOverlay({
    title,
    content: `<p>${message}</p>`,
    actions: [
      { text: 'Cancel', class: 'uk-btn uk-btn-secondary', action: () => { closeOverlay(id); onCancel && onCancel(); } },
      { text: 'Confirm', class: 'uk-btn uk-btn-primary', action: () => { closeOverlay(id); onConfirm && onConfirm(); } }
    ]
  });
  return id;
}

export default { openOverlay, closeOverlay, confirmOverlay };
